import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Service from '../../booking/components/Service';
import { removeService, addServiceItem } from '../../../data/booking/actions/booking';
import includes from 'lodash/includes';
import * as serviceTypes from '../../../data/booking/constants/service_types';
import { getServiceSummary } from '../../../data/booking/selectors/summary';
import { getServiceIsEditing, getHasEditingItem } from '../../../data/booking/selectors/booking';
import {addStep, selectHike, startTripEdit} from "../../../data/booking/actions/map";

class ServiceContainer extends Component {
    static propTypes = {
        service: PropTypes.object,
        showActions: PropTypes.bool,
        isEditing: PropTypes.bool,
        hasEditingItem: PropTypes.bool,
        removeService: PropTypes.func,
        addStep: PropTypes.func,
        selectHike: PropTypes.func,
        startTripEdit: PropTypes.func,
        addServiceItem: PropTypes.func
    };

    static defaultProps = {
        showActions: false
    };

    handleAddItem() {
        //this.props.selectHike(this.props.service.hike)
        //this.props.startTripEdit()
        this.props.addStep(this.props.service.id);
        this.props.addServiceItem(this.props.service.id)
    }

    handleRemove() {
        this.props.removeService(this.props.service.id);
    }

    render() {
        const { service, showActions, isEditing, hasEditingItem} = this.props;
        const showAddButton = includes([
            serviceTypes.BAG_TRANSPORT,
        ], service.type);

        return (
            <Service
                service={{
                    ...service,
                    summary: getServiceSummary(service)
                }}
                isActive={isEditing}
                hasEditingItem={hasEditingItem}
                onAddItem={((showActions === true || showActions.add === true) && showAddButton) ? ::this.handleAddItem : null}
                showActions={showActions}
            />
        );
    }
}


export default connect(
    (state, props) => ({
        items:state.booking.booking.entities.items,
        isEditing: getServiceIsEditing(state.booking, props.service),
        hasEditingItem: getHasEditingItem(state.booking)
    }),
    dispatch => bindActionCreators({ removeService, addServiceItem, addStep, selectHike, startTripEdit }, dispatch)
)(ServiceContainer);
